export type ResultDownloadFile = {
  fileName: string;
  folderName: string;
  path?: string;
};

export type ResultDownloadPhase = "done" | "download" | "error" | "zip";

export type ResultDownloadProgress = {
  completed: number;
  failed: number;
  percentage: number;
  phase: ResultDownloadPhase;
  total: number;
};

export const EMPTY_RESULT_DOWNLOAD_PROGRESS: ResultDownloadProgress = {
  completed: 0,
  failed: 0,
  percentage: 0,
  phase: "download",
  total: 0,
};
